import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "animated fadeIn background-color" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "card border-top-2 border-top-info col-md-8 offset-md-2 text-left" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center\"><img class=\"navbar-brand-full\" src=\"img/logo.png\" height=\"100\" alt=\"LO Logo\"><h2>Learning Online Registration</h2></div><ul class=\"step d-flex flex-nowrap pt-4\"><li class=\"step-item active\"><span>Step 1<br>Student registers</span></li><li class=\"step-item\"><span>Step 2<br>Student &amp; parent/guardian agree to appropriate policy documents</span></li><li class=\"step-item\"><span>Step 3<br>Student enrollments will be reviewed and approved</span></li><li class=\"step-item\"><span>Step 4<br>Student will be enrolled into classes</span></li></ul><br>", 3)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row mt-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Student Type", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_12 = {
  key: 0,
  class: "row mx-2"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("u", null, "Additional Information", -1)
const _hoisted_14 = { class: "row mt-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "First Name", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Middle Name", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Last Name", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_20 = { class: "row mt-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Gender", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Number & Street/PO Box", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_26 = { class: "row mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "City", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Province", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Postal Code", -1)
const _hoisted_32 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_33 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_34 = { class: "row mt-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Phone Number", -1)
const _hoisted_36 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_37 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_38 = { class: "row mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "Year of Graduation", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-tooltip" }, "This field is required", -1)
const _hoisted_41 = { class: "row mt-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", null, "Aboriginal Status (voluntary)", -1)
const _hoisted_43 = { class: "row mt-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "Citizenship 1", -1)
const _hoisted_45 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", null, "Citizenship 2", -1)
const _hoisted_47 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "Resident Type", -1)
const _hoisted_49 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_50 = { class: "row mt-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", null, "1st Language", -1)
const _hoisted_52 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", null, "2nd Language", -1)
const _hoisted_54 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_55 = { class: "row mt-3" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", null, "Country of Birth", -1)
const _hoisted_57 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "Country of Origin", -1)
const _hoisted_59 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_60 = { class: "row mt-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", null, "Student's Religion", -1)
const _hoisted_62 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", null, "Mother's Religion", -1)
const _hoisted_64 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", null, "Father's Religion", -1)
const _hoisted_66 = {
  key: 0,
  class: "custom-invalid-tooltip"
}
const _hoisted_67 = { class: "row mt-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", null, "Student's Cell", -1)
const _hoisted_69 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_70 = { class: "row mt-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Student Email", -1)
const _hoisted_72 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_73 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_74 = {
  key: 2,
  class: "invalid-tooltip"
}
const _hoisted_75 = { class: "row mt-3" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", null, "Confirm Student Email", -1)
const _hoisted_77 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_78 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_79 = { class: "row mt-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", null, "Sask Learning ID", -1)
const _hoisted_81 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_82 = { class: "row mt-3" }
const _hoisted_83 = { class: "col" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "form-group mb-0 required" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Courses")
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_86 = { class: "text-center" }
const _hoisted_87 = {
  key: 0,
  class: "text-center"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = {
  key: 1,
  class: "text-center"
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = {
  key: 1,
  class: "mx-auto fw-bold"
}
const _hoisted_99 = { class: "row mt-3" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Parent/Guardian First Name", -1)
const _hoisted_101 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", null, "Parent/Guardian Last Name", -1)
const _hoisted_103 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_104 = { class: "row mt-3" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", null, "Parent/Guardian Email", -1)
const _hoisted_106 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_107 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_108 = { class: "row mt-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", null, "Confirm Parent/Guardian Email", -1)
const _hoisted_110 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_111 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_112 = { class: "row mt-3" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("label", null, "Parent/Guardian Phone", -1)
const _hoisted_114 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_115 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_116 = { class: "row mt-3" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", null, "School Division", -1)
const _hoisted_118 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", null, "School Division", -1)
const _hoisted_120 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_121 = { class: "row mt-3" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", null, "School", -1)
const _hoisted_123 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", null, "School", -1)
const _hoisted_125 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_126 = { class: "row mt-3" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", null, "School Contact First Name", -1)
const _hoisted_128 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", null, "School Contact Last Name", -1)
const _hoisted_130 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_131 = { class: "row mt-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", null, "School Contact Email", -1)
const _hoisted_133 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_134 = {
  key: 1,
  class: "invalid-tooltip"
}
const _hoisted_135 = {
  class: "row px-1 py-2 mt-3 mx-0",
  style: {"border":"1px solid #e4e7ea","border-radius":"0.25em"}
}
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Is this student attending classes at another school division?")
], -1)
const _hoisted_137 = { class: "form-check" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios1"
}, " Yes (Please provide details in the Additional Information section below) ", -1)
const _hoisted_139 = { class: "form-check" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "exampleRadios2"
}, " No ", -1)
const _hoisted_141 = {
  key: 0,
  class: "custom-invalid-tooltip",
  style: {"right":"-8px","margin-top":"10px"}
}
const _hoisted_142 = { class: "col-12 mt-4" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", null, "Last Attended School Division", -1)
const _hoisted_144 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", null, "Last Attended School Division", -1)
const _hoisted_146 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_147 = { class: "col-12 mt-3" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("label", null, "Last Attended School", -1)
const _hoisted_149 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("label", null, "Last Attended School", -1)
const _hoisted_151 = {
  key: 0,
  class: "invalid-tooltip"
}
const _hoisted_152 = { class: "row mt-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Partner in Education"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "Are you a member of one of these partner organizations?")
], -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Tuition Fees and Rules"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" Course Tuition (Regular School Year) - $500 per course "),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, " Tuition is waived for RCSD students and students who are 21 years or younger on September 30 of the school year the course is completed and are not enrolled with another school division. "),
          /*#__PURE__*/_createElementVNode("li", null, " International Student Course Tuition - $1300 per course ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" Summer Course Tuition - $500 per course "),
        /*#__PURE__*/_createElementVNode("ul", null, [
          /*#__PURE__*/_createElementVNode("li", null, " International Student Summer Course Tuition - $1000 per course ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_156 = { class: "row mt-3" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Reason for Application and/or Additional Information", -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("small", null, "This information will be available to Learning Online administration and/or base school administration for consideration during application review.", -1)
const _hoisted_160 = {
  key: 0,
  class: "custom-invalid-tooltip my-2"
}
const _hoisted_161 = { class: "row mt-3" }
const _hoisted_162 = { class: "form-group col" }
const _hoisted_163 = {
  key: 0,
  class: "custom-invalid-tooltip mb-2"
}
const _hoisted_164 = { class: "row mt-3" }
const _hoisted_165 = { class: "col" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-4" }, " Student registration is dependent upon approval from the base school administration. ", -1)
const _hoisted_167 = { class: "d-grid gap-2" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("span", null, "Submit Registration", -1)
const _hoisted_169 = { key: 1 }
const _hoisted_170 = { class: "row mt-3" }
const _hoisted_171 = { class: "col text-center" }
const _hoisted_172 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-check-circle fa-5x text-success",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-2 mb-3" }, "Your registration has been received.", -1)
const _hoisted_175 = { key: 0 }

import vSelect from "vue-select";
import axiosdb from "@/axios-db";
import axiosaux from "@/axios-aux";
import dateFormat from "dateformat";
import { jsonToGraphQLQuery, EnumType } from "json-to-graphql-query";
import LoadingModal from "@/shared/LoadingModal.vue";
import ErrorModal from "@/shared/ErrorModal.vue";
import { vMaska } from "maska/vue";
import lodash from "lodash";
import {
  BAlert,
  BButton,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BFormTextarea,
  BRow,
  BTooltip,
} from "bootstrap-vue-next";
import vueRecaptcha from "vue3-recaptcha2";

import { required, requiredIf, email, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { computed, onMounted, reactive, ref, toRefs, watchEffect } from "vue";
import { useToast } from "vue-toast-notification";
import { DateParts } from "v-calendar/dist/types/src/utils/date/helpers";
import { CalendarDay } from "v-calendar/dist/types/src/utils/page";

interface DateRange {
  start: Date;
  end: Date;
}
interface CourseInfo {
  courseId: number;
  requestedStartDate: Date;
  isWaitlist: boolean;
}

//Validators for vuelidate

export default /*#__PURE__*/_defineComponent({
  __name: 'Registration',
  setup(__props) {

const toast = useToast();

const postalCodeValidator = (value: any) =>
  !helpers.req(value) || /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(value);
const phoneValidator = (value: any) =>
  !helpers.req(value) || /^[1-9]\d{2}-\d{3}-\d{4}/.test(value);
const mustBeTrue = (value: boolean) => value;

const showLoading = ref<boolean>(false);
const showError = ref<boolean>(false);
const disabledDates = ref<any>([]);
const invisibleRecaptcha = ref();

const state = reactive<any>({
  submitted: false,
  // temproary write access token
  guestToken: null,
  authGuestToken: null,
  // Get field values from the API
  studentTypes: [],
  aboriginalities: [],
  countries: [],
  residentTypes: [],
  languages: [],
  religions: [],
  schools: [],
  schoolDivisions: [],
  schoolYears: [],
  educationPartners: [],
  requirements: null,
  // The selected options on the form
  studentType: null,
  firstname: null,
  middlename: null,
  lastname: null,
  gender: null,
  street: null,
  city: null,
  province: null,
  postalcode: null,
  phone: null,
  dob: null,
  yog: null,
  aboriginality: null,
  citizenship1: null,
  citizenship2: null,
  residentType: null,
  language1: null,
  language2: null,
  cob: null,
  coo: null,
  studentReligion: null,
  motherReligion: null,
  fatherReligion: null,
  studentCell: null,
  studentEmail: null,
  studentEmail2: null,
  ministryNo: null,
  parentFirstName: null,
  parentLastName: null,
  parentEmail: null,
  parentEmail2: null,
  parentPhone: null,
  schoolDivision: null,
  schoolDivisionOther: null,
  school: null,
  schoolOther: null,
  schoolContactFirstName: null,
  schoolContactLastName: null,
  schoolContactEmail: null,
  attendingOtherSchoolDivision: null,
  lastAttendedSchoolDivision: null,
  lastAttendedSchoolDivisionOther: null,
  lastAttendedSchool: null,
  lastAttendedSchoolOther: null,
  lastAttendedDate: null,
  partnerInEducation: null,
  notes: null,
  eligibilityGuidelines: false,
  prereqs: false,
  accurate: false,
  recordsShared: false,
  recaptchaResponse: null,
  // The courses pulled out of the api
  courses: [],
  selectedCourses: [],
  loadRecaptcha: false,
  buttonEnabled: true,
});

const { selectedCourses } = toRefs(state);
const confirmEmail = (value: string, other: string) => value === other;

const validations = {
  studentType: {
    required,
  },
  firstname: {
    required,
  },
  middlename: {},
  lastname: {
    required,
  },
  gender: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  street: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  city: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  province: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  postalcode: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
    postalCodeValidator,
  },
  phone: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
    phoneValidator,
  },
  dob: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  yog: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_yog
      );
    }),
  },
  aboriginality: {},
  citizenship1: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_citizenship
      );
    }),
  },
  citizenship2: {},
  residentType: {
    required: requiredIf(function () {
      return state.citizenship1 && state.citizenship1.label != "Canada";
    }),
  },
  language1: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_language
      );
    }),
  },
  language2: {},
  cob: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_origins
      );
    }),
  },
  coo: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_origins
      );
    }),
  },
  studentReligion: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_religion
      );
    }),
  },
  motherReligion: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_religion
      );
    }),
  },
  fatherReligion: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_religion
      );
    }),
  },
  studentCell: {
    phoneValidator,
  },
  studentEmail: {
    required,
    email,
    confirmEmail: !confirmEmail(state.studentEmail, state.parentEmail),
  },
  studentEmail2: {
    required,
    email,
  },
  ministryNo: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_additional_sis_data
      );
    }),
  },
  parentFirstName: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_parent
      );
    }),
  },
  parentLastName: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_parent
      );
    }),
  },
  parentEmail: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_parent
      );
    }),
    email,
    confirmEmail: !confirmEmail(state.studentEmail, state.parentEmail),
  },
  parentEmail2: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_parent
      );
    }),
    confirmEmail: confirmEmail(state.parentEmail2, state.parentEmail),
  },
  parentPhone: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_parent
      );
    }),
    phoneValidator,
  },
  schoolDivision: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_school_division
      );
    }),
  },
  schoolDivisionOther: {
    required: requiredIf(function () {
      return state.schoolDivision == "Other";
    }),
  },
  school: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_school
      );
    }),
  },
  schoolOther: {
    required: requiredIf(function () {
      return state.school == "Other";
    }),
  },
  schoolContactFirstName: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_school_contact
      );
    }),
  },
  schoolContactLastName: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_school_contact
      );
    }),
  },
  schoolContactEmail: {
    email,
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_school_contact
      );
    }),
  },
  attendingOtherSchoolDivision: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_attending_other_school_div
      );
    }),
  },
  lastAttendedSchoolDivision: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_attending_other_school_div &&
        state.attendingOtherSchoolDivision == "false"
      );
    }),
  },
  lastAttendedSchoolDivisionOther: {
    required: requiredIf(function () {
      return state.lastAttendedSchoolDivision == "Other";
    }),
  },
  lastAttendedSchool: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_attending_other_school_div &&
        state.attendingOtherSchoolDivision == "false"
      );
    }),
  },
  lastAttendedSchoolOther: {
    required: requiredIf(function () {
      return state.lastAttendedSchool == "Other";
    }),
  },
  lastAttendedDate: {
    required: requiredIf(function () {
      return (
        state.studentType &&
        state.studentTypes.filter((a) => a.id == state.studentType)[0]
          .require_attending_other_school_div &&
        state.attendingOtherSchoolDivision == "false"
      );
    }),
  },
  partnerInEducation: {},
  eligibilityGuidelines: {
    mustBeTrue,
  },
  prereqs: {
    mustBeTrue,
  },
  accurate: {
    mustBeTrue,
  },
  recordsShared: {
    mustBeTrue,
  },
  notes: {
    required,
  },
};

const $v = useVuelidate(validations, state);

function toGQL(queryObject: any, variables = {}) {
  // Using the jsonToGraphQuery library to convert the json defined query into a graphQL query
  return { query: jsonToGraphQLQuery(queryObject), variables: variables };
}

async function loadFormData() {
  showLoading.value = true;

  let query = {
    query: {
      halo_student_type: {
        __args: {
          order_by: { sort_order: new EnumType("desc") },
        },
        id: true,
        name: true,
        require_additional_sis_data: true,
        require_attending_other_school_div: true,
        require_citizenship: true,
        require_language: true,
        require_origins: true,
        require_parent: true,
        require_religion: true,
        require_school: true,
        require_school_contact: true,
        require_school_division: true,
        require_yog: true,
        require_partner_in_education: true,
      },
      halo_aboriginality: {
        id: true,
        name: true,
      },
      halo_country: {
        id: true,
        name: true,
      },
      halo_resident_type: {
        id: true,
        name: true,
      },
      halo_language: {
        id: true,
        name: true,
      },
      halo_religion: {
        id: true,
        name: true,
      },
      halo_school: {
        __args: {
          order_by: { name: new EnumType("asc") },
        },
        id: true,
        name: true,
      },
      halo_school_division: {
        __args: {
          order_by: { name: new EnumType("asc") },
        },
        id: true,
        name: true,
      },
      halo_education_partner: {
        __args: {
          order_by: { name: new EnumType("asc") },
        },
        id: true,
        name: true,
      },
      halo_course: {
        __args: {
          order_by: { name: new EnumType("asc") },
        },
        id: true,
        name: true,
        length: true,
      },
      halo_school_year: {
        name: true,
        start_date: true,
        end_date: true,
        summer_start_date: true,
        summer_end_date: true,
      },
    },
  };

  try {
    let res = await axiosdb.post(
      "/graphql?t=" + new Date().valueOf(),
      toGQL(query)
    );
    state.studentTypes = res.data.data.halo_student_type;
    state.aboriginalities = res.data.data.halo_aboriginality.map((a: any) => {
      return { text: a.name, value: a.id };
    });
    state.countries = res.data.data.halo_country.map((a: any) => {
      return { label: a.name, value: a.id };
    });
    state.residentTypes = res.data.data.halo_resident_type.map((a: any) => {
      return { label: a.name, value: a.id };
    });
    state.languages = res.data.data.halo_language.map((a: any) => {
      return { label: a.name, value: a.id };
    });
    state.religions = res.data.data.halo_religion.map((a: any) => {
      return { label: a.name, value: a.id };
    });
    state.schools = res.data.data.halo_school.map((a: any) => {
      return a.name;
    });
    state.schoolDivisions = res.data.data.halo_school_division.map((a: any) => {
      return a.name;
    });
    state.courses = res.data.data.halo_course.map((a: any) => {
      return { label: a.name, value: a.id, length: a.length };
    });
    state.schoolYears = res.data.data.halo_school_year;
    state.educationPartners = res.data.data.halo_education_partner.map(
      (a: any) => {
        return { text: a.name, value: a.id };
      }
    );
    showLoading.value = false;
  } catch (err) {
    console.log(err);
    showLoading.value = false;

    showError.value = true;
  }
}

async function changeCourseInput(index: number) {
  // the index being passed here is the index of this particular dropdown in the state.selectedCourses array
  // If the course drop down is changed we clear all the variables
  state.selectedCourses[index].availableStartDates = [];
  state.selectedCourses[index].calendarAttrs = [];
  state.selectedCourses[index].startDate = null;

  // If, after the change, there is still a course, then we should get that information
  if (state.selectedCourses[index].course) {
    // Load the available dates from the API for the selected course
    showLoading.value = true;

    let query = {
      query: {
        halo_course_availability: {
          __args: {
            course_id: state.selectedCourses[index].course.value,
          },
          full_dates: true,
          open_dates: true,
        },
      },
    };

    await axiosdb
      .post("/graphql?t=" + new Date().valueOf(), toGQL(query))
      .then((result) => {
        showLoading.value = false;
        state.selectedCourses[index].availableStartDates = lodash.union(
          result.data.data.halo_course_availability.open_dates,
          result.data.data.halo_course_availability.full_dates
        );
        state.selectedCourses[index].openDates =
          result.data.data.halo_course_availability.open_dates;
        state.selectedCourses[index].fullDates =
          result.data.data.halo_course_availability.full_dates;

        disabledDates.value = [
          {
            start: null,
            end: null,
            on: [
              (days) =>
                !result.data.data.halo_course_availability.open_dates.includes(
                  days.date
                ),
            ],
          },
        ];

        state.selectedCourses[index].calendarAttrs.push({
          key: "open",
          dates: buildDateObject(
            result.data.data.halo_course_availability.open_dates
          ),
          bar: "green",
          content: {
            style: {
              color: "black",
            },
          },
          popover: {
            label: "This date is available",
          },
        });
        state.selectedCourses[index].calendarAttrs.push({
          key: "full",
          dates: buildDateObject(
            result.data.data.halo_course_availability.full_dates
          ),
          bar: "yellow",
          content: {
            style: {
              color: "black",
            },
          },
          popover: {
            label: "This date is full, you will be added to the waitlist",
          },
        });
      })
      .catch((err) => {
        console.log("err", err);
        showLoading.value = false;
        showError.value = true;
        toast.error("Error occurred retrieving availability of courses");
      });
  }
}

function onlyEnableAllowedDates(
  component: number,
  dateParts: DateParts,
  index: number
) {
  return state.selectedCourses[index].openDates.includes(dateParts.date);
}
function removeSelectedCourse(index: number) {
  state.selectedCourses.splice(index, 1);
}

function pickDate(calendarDay: CalendarDay, courseIndex: number) {
  const currentCourse = state.selectedCourses[courseIndex];

  if (
    !currentCourse.openDates.some(
      (date) => new Date(date).getTime() == calendarDay.date.getTime()
    ) && !currentCourse.fullDates.some(
      (date) => new Date(date).getTime() == calendarDay.date.getTime()
    )
  ) {
    state.selectedCourses[courseIndex].startDate = null;
  }
  // Remove the existing span from the calendarAttrs array if it exists.  we don't want two spans on the calendar
  let spanIndex = state.selectedCourses[courseIndex].calendarAttrs.findIndex(
    (a: any) => a.key == "selectedSpan"
  );
  if (spanIndex >= 0) {
    state.selectedCourses[courseIndex].calendarAttrs.splice(spanIndex, 1);
  }
  // If the date was DESELECTED then we don't need to continue, we don't have a date to work with
  if (!state.selectedCourses[courseIndex].startDate) {
    return;
  }

  // We have picked a date, now we find out if that date falls within a standard September-June school year
  // If schoolYear is defined after this find it will be the school year with the start and end dates.  If it isn't then the
  // date picked is a summer class and we shouldn't have to worry about suspensions.  If the span created by the date
  // selected goes past the end of the semester that is returned then we have to account for that.

  let schoolYear: any = state.schoolYears.find(
    (sy: any) =>
      new Date(sy.start_date) <=
        new Date(state.selectedCourses[courseIndex].startDate) &&
      new Date(sy.end_date) >=
        new Date(state.selectedCourses[courseIndex].startDate)
  );
  let spans: DateRange[] = [];

  // Check to see if the start date plus the length goes beyond the last day of the semester.
  if (
    schoolYear &&
    addDays(
      state.selectedCourses[courseIndex].startDate,
      state.selectedCourses[courseIndex].course.length - 1
    ) > new Date(schoolYear.end_date)
  ) {
    // If the end date of the enrollment goes past the end date of the semester then we only make the span until the end of the semester
    spans.push({
      start: state.selectedCourses[courseIndex].startDate,
      end: new Date(schoolYear.end_date),
    });
    // To show this information to the user on the screen we do some calculations
    state.selectedCourses[courseIndex].willBeSuspended = true;
    state.selectedCourses[courseIndex].semesterEndDate = new Date(
      schoolYear.end_date
    );
    state.selectedCourses[courseIndex].amountCompleteBeforeSuspension =
      dateDiffInDays(
        state.selectedCourses[courseIndex].startDate,
        new Date(schoolYear.end_date)
      ) + 1;
  } else {
    // If the end date of the enrollment is within the semester end date then we just make the span for the full length
    spans.push({
      start: state.selectedCourses[courseIndex].startDate,
      end: addDays(
        state.selectedCourses[courseIndex].startDate,
        state.selectedCourses[courseIndex].course.length - 1
      ),
    });
    state.selectedCourses[courseIndex].willBeSuspended = false;
    state.selectedCourses[courseIndex].amountCompleteBeforeSuspension = null;
  }
  // If the date was selected then we create the span to display on the calendar
  state.selectedCourses[courseIndex].calendarAttrs.push({
    key: "selectedSpan",
    highlight: {
      color: "purple",
    },
    dates: spans,
  });
}

function buildDateObject(dates: any[]) {
  let dArray: DateRange[] = [];
  for (let d of dates) {
    dArray.push({ start: d, end: d });
  }
  // If there is nothing then the only available date is one day in 1969... if this is a blank array
  // then all dates become available.
  if (dArray.length == 0) {
    dArray.push({ start: new Date(1 * 1000), end: new Date(1 * 1000) });
  }
  return dArray;
}

async function verifyData() {

  console.log(state.selectedCourses)
  // check all the validator fields to make sure they are filled in
  $v.value.$touch();
  if (state.parentEmail == state.studentEmail) {
    toast.error(
      "Your student email cannot be the same as your parent's email!"
    );
    return;
  }

  if (!(await $v.value.$validate())) {
    console.log($v.value.$errors);
    toast.error(
      "Some fields incomplete or invalid, please go back and correct this"
    );
    return;
  }
  // do extra checks to ensure the student has picked courses
  if (state.selectedCourses.length == 0) {
    toast.error("Please add at least one course");
    return;
  }

  for (let c of state.selectedCourses) {
    if (!c.course) {
      toast.error(
        "Please select a course from the drop down or remove the course"
      );
      return;
    }
    if (!c.startDate) {
      toast.error("Please select a valid start date for " + c.course.label);
      return;
    }
  }

  state.buttonEnabled = false;
  invisibleRecaptcha.value.execute();
}

function recaptchaCallback(recaptchaToken: string) {
  axiosaux
    .post("/auth/verify-captcha", { recaptchaToken: recaptchaToken })
    .then((result) => {
      showLoading.value = true;
      sendRegistration();
    })
    .catch(() => {
      toast.error("Error occured during submission");
    });
}

function onExpired() {
  invisibleRecaptcha.value.reset();
}

async function sendRegistration() {
  let mutation: any = {
    mutation: {
      halo_student_register: {
        __args: {
          student_type_id: state.studentType,
          first_name: state.firstname,
          middle_name: state.middlename,
          last_name: state.lastname,
          gender: state.gender,
          phone: state.phone,
          dob: state.dob ? state.dob.toString() : null,
          yog: state.yog,
          aboriginality_id: state.aboriginality,
          citizenship1_id: state.citizenship1 ? state.citizenship1.value : null,
          citizenship2_id: state.citizenship2 ? state.citizenship2.value : null,
          resident_type_id: state.residentType
            ? state.residentType.value
            : null,
          language1_id: state.language1 ? state.language1.value : null,
          language2_id: state.language2 ? state.language2.value : null,
          birth_country_id: state.cob ? state.cob.value : null,
          origin_country_id: state.coo ? state.coo.value : null,
          student_religion_id: state.studentReligion
            ? state.studentReligion.value
            : null,
          mother_religion_id: state.motherReligion
            ? state.motherReligion.value
            : null,
          father_religion_id: state.fatherReligion
            ? state.fatherReligion.value
            : null,
          cell: state.studentCell,
          email: state.studentEmail,
          ministry_id: state.ministryNo,
          school_division: state.schoolDivisionOther
            ? state.schoolDivisionOther
            : state.schoolDivision,
          school: state.schoolOther ? state.schoolOther : state.school,
          attending_other_school_division:
            state.attendingOtherSchoolDivision == "true" ? true : false,
          last_attended_school_division: state.lastAttendedSchoolDivisionOther
            ? state.lastAttendedSchoolDivisionOther
            : state.lastAttendedSchoolDivision,
          last_attended_school: state.lastAttendedSchoolOther
            ? state.lastAttendedSchoolOther
            : state.lastAttendedSchool,
          last_attended_date: state.lastAttendedDate
            ? state.lastAttendedDate.toString()
            : null,
          education_partner_id: state.partnerInEducation,
          notes: state.notes,
          agreed_to_eligibility_guidelines: state.eligibilityGuidelines,
          agreed_to_prereqs_complete: state.prereqs,
          agreed_to_information_accurate: state.accurate,
          agreed_to_information_shared: state.recordsShared,
          street: state.street || null,
          city: state.city || null,
          province: state.province || null,
          postal_code: state.postalcode || null,
        },
        result: true,
      },
    },
  };

  if (
    state.studentType &&
    state.studentTypes.filter((a: any) => a.id == state.studentType)[0]
      .require_parent
  ) {
    mutation.mutation.halo_student_register.__args._parents = [
      {
        firstname: state.parentFirstName,
        lastname: state.parentLastName,
        email: state.parentEmail,
        phone: state.parentPhone,
      },
    ];
  }

  if (
    state.studentType &&
    state.studentTypes.filter((a: any) => a.id == state.studentType)[0]
      .require_school_contact
  ) {
    mutation.mutation.halo_student_register.__args._school_contacts = [
      {
        firstname: state.schoolContactFirstName,
        lastname: state.schoolContactLastName,
        email: state.schoolContactEmail,
      },
    ];
  }

  let courses: CourseInfo[] = [];

  for (let selectedCourse of state.selectedCourses) {
    if (
      selectedCourse.fullDates.filter(
        (a: any) =>
          new Date(a).toString() ==
          new Date(selectedCourse.startDate).toString()
      ).length > 0
    ) {
      courses.push({
        courseId: selectedCourse.course.value,
        requestedStartDate: selectedCourse.startDate.toString(),
        isWaitlist: true,
      });
    } else {
      courses.push({
        courseId: selectedCourse.course.value,
        requestedStartDate: selectedCourse.startDate.toString(),
        isWaitlist: false,
      });
    }
  }

  mutation.mutation.halo_student_register.__args.courses = courses;

  try {
    let res = await axiosdb.post(
      "/graphql?t=" + new Date().valueOf(),
      toGQL(mutation)
    );
    if (res.data.data.halo_student_register.result === true) {
      state.submitted = true;
    } else {
      toast.error("An error has occured during registration");
    }
    if (res.data.errors) {
      toast.error("An error has occured during registration");
    }
  } catch (err) {
    toast.error("An error has occured during registration");
  }

  showLoading.value = false;
}

function resetForm() {
  (state.submitted = false),
    (state.guestToken = null),
    (state.authGuestToken = null),
    (state.requirements = null),
    (state.studentType = null),
    (state.firstname = null),
    (state.middlename = null),
    (state.lastname = null),
    (state.gender = null),
    (state.street = null),
    (state.city = null),
    (state.province = null),
    (state.postalcode = null),
    (state.phone = null),
    (state.dob = null),
    (state.aboriginality = null),
    (state.citizenship1 = null),
    (state.citizenship2 = null),
    (state.residentType = null),
    (state.language1 = null),
    (state.language2 = null),
    (state.cob = null),
    (state.coo = null),
    (state.studentReligion = null),
    (state.motherReligion = null),
    (state.fatherReligion = null),
    (state.studentCell = null),
    (state.studentEmail = null),
    (state.studentEmail2 = null),
    (state.ministryNo = null),
    (state.parentFirstName = null),
    (state.parentLastName = null),
    (state.parentEmail = null),
    (state.parentEmail2 = null),
    (state.parentPhone = null),
    (state.schoolDivision = null),
    (state.schoolDivisionOther = null),
    (state.school = null),
    (state.schoolOther = null),
    (state.schoolContactFirstName = null),
    (state.schoolContactLastName = null),
    (state.schoolContactEmail = null),
    (state.attendingOtherSchoolDivision = null),
    (state.partnerInEducation = null),
    (state.notes = null),
    (state.eligibilityGuidelines = false),
    (state.prereqs = false),
    (state.accurate = false),
    (state.recordsShared = false),
    (state.recaptchaResponse = null);
  state.selectedCourses = [];
  $v.value.$reset();
}

function validityColor(data: any) {
  if ($v.value[data].$error) return "is-invalid";
  else if (
    $v.value[data].$dirty &&
    !$v.value[data].$invalid &&
    $v.value[data].$model
  )
    return "is-valid";

  return "";
}

function addDays(date: any, days: number) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function dateDiffInDays(a: Date, b: Date) {
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
}

const selectableCourses = computed(() => {
  let alreadySelected = state.selectedCourses.map((a) => a.course);
  return lodash.difference(state.courses, alreadySelected);
});

onMounted(() => {
  setTimeout(() => (state.loadRecaptcha = true), 2000);
  setTimeout(() => loadFormData(), 1000);
});

return (_ctx: any,_cache: any) => {
  const _component_CDatePicker = _resolveComponent("CDatePicker")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (!state.submitted)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col", { required: _unref($v).studentType.hasOwnProperty('required') }])
                  }, [
                    _hoisted_10,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).studentType.$model,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref($v).studentType.$model) = $event)),
                      options: 
                    state.studentTypes?.map((a) => {
                      return { text: a.name, value: a.id };
                    })
                  ,
                      class: _normalizeClass(validityColor('studentType'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    _hoisted_11
                  ], 2)
                ]),
                (state.studentType === 6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_unref(BAlert), {
                        class: "mt-4",
                        variant: "warning",
                        "model-value": true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("In the "),
                          _hoisted_13,
                          _createTextVNode(" section at the bottom of this form, please provide a brief explanation as to why your child is registering with Learning Online. All registrations will be reviewed by program administration prior to approval.")
                        ], undefined, true),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).firstname.hasOwnProperty('required') }])
                  }, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('firstname')]),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref($v).firstname.$model) = $event)),
                      name: "firstname"
                    }, null, 2), [
                      [_vModelText, _unref($v).firstname.$model]
                    ]),
                    _hoisted_16
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).middlename.hasOwnProperty('required') }])
                  }, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('middlename')]),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref($v).middlename.$model) = $event)),
                      name: "middlename"
                    }, null, 2), [
                      [_vModelText, _unref($v).middlename.$model]
                    ])
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).lastname.hasOwnProperty('required') }])
                  }, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('lastname')]),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref($v).lastname.$model) = $event)),
                      name: "lastname"
                    }, null, 2), [
                      [_vModelText, _unref($v).lastname.$model]
                    ]),
                    _hoisted_19
                  ], 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).gender.hasOwnProperty('required') }])
                  }, [
                    _hoisted_21,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).gender.$model,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref($v).gender.$model) = $event)),
                      options: ['Male', 'Female', 'Other/Unspecified'],
                      class: _normalizeClass(validityColor('gender'))
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_22
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).street.hasOwnProperty('required') }])
                  }, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('street')]),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref($v).street.$model) = $event)),
                      name: "address1"
                    }, null, 2), [
                      [_vModelText, _unref($v).street.$model]
                    ]),
                    _hoisted_25
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).city.hasOwnProperty('required') }])
                  }, [
                    _hoisted_27,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('city')]),
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref($v).city.$model) = $event)),
                      name: "city"
                    }, null, 2), [
                      [_vModelText, _unref($v).city.$model]
                    ]),
                    _hoisted_28
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).province.hasOwnProperty('required') }])
                  }, [
                    _hoisted_29,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).province.$model,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref($v).province.$model) = $event)),
                      options: [
                    { text: 'Alberta', value: 'AB' },
                    { text: 'British Columbia', value: 'BC' },
                    { text: 'Manitoba', value: 'MB' },
                    { text: 'New Brunswick', value: 'NB' },
                    { text: 'Newfoundland and Labrador', value: 'NL' },
                    { text: 'Nova Scotia', value: 'NS' },
                    { text: 'Northwest Territories', value: 'NT' },
                    { text: 'Nunavut', value: 'NU' },
                    { text: 'Ontario', value: 'ON' },
                    { text: 'Prince Edward Island', value: 'PE' },
                    { text: 'Quebec', value: 'QC' },
                    { text: 'Saskatchewan', value: 'SK' },
                    { text: 'Yukon', value: 'YT' },
                  ],
                      class: _normalizeClass(validityColor('province'))
                    }, null, 8, ["modelValue", "class"]),
                    _hoisted_30
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).postalcode.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_31,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('postalcode')]),
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.postalcode) = $event)),
                      onBlur: _cache[9] || (_cache[9] = ($event: any) => (_unref($v).postalcode.$touch())),
                      "data-maska-tokens": "{ 'Z' : { 'pattern': '[A-z]'}}",
                      onInput: _cache[10] || (_cache[10] = ($event: any) => (state.postalcode = state.postalcode.toUpperCase())),
                      name: "postalcode"
                    }, null, 34), [
                      [_vModelText, state.postalcode],
                      [_unref(vMaska), 'Z#Z #Z#']
                    ]),
                    (!_unref($v).postalcode.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, " This field is required "))
                      : _createCommentVNode("", true),
                    (
                    _unref($v).postalcode.required && !_unref($v).postalcode.postalCodeValidator
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, " Not a valid postal code "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).phone.hasOwnProperty('required') }])
                  }, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('phone')]),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.phone) = $event)),
                      onBlur: _cache[12] || (_cache[12] = ($event: any) => (_unref($v).phone.$touch())),
                      name: "phone"
                    }, null, 34), [
                      [_vModelText, state.phone],
                      [_unref(vMaska), '###-###-####']
                    ]),
                    (!_unref($v).phone.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, " This field is required "))
                      : _createCommentVNode("", true),
                    (_unref($v).phone.required && !_unref($v).phone.phoneValidator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Not a valid phone number "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["row big-date mt-3", { required: _unref($v).dob.hasOwnProperty('required') }])
                }, [
                  _createVNode(_component_CDatePicker, {
                    class: _normalizeClass(validityColor('dob')),
                    label: "Date of Birth",
                    "onUpdate:date": _cache[13] || (_cache[13] = (date) => (_unref($v).dob.$model = date))
                  }, null, 8, ["class"])
                ], 2), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).yog.hasOwnProperty('required') }])
                  }, [
                    _hoisted_39,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).yog.$model,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref($v).yog.$model) = $event)),
                      class: _normalizeClass(validityColor('yog'))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
                          return _createElementVNode("option", { key: n }, _toDisplayString(new Date().getFullYear() + (n - 2)), 1)
                        }), 64))
                      ], undefined, true),
                      _: 1
                    }, 8, ["modelValue", "class"]),
                    _hoisted_40
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_yog
              ]
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).aboriginality.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_42,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).aboriginality.$model,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref($v).aboriginality.$model) = $event)),
                      options: state.aboriginalities,
                      class: _normalizeClass(validityColor('aboriginality'))
                    }, null, 8, ["modelValue", "options", "class"])
                  ], 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).citizenship1.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_44,
                    _createVNode(_unref(vSelect), {
                      modelValue: _unref($v).citizenship1.$model,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref($v).citizenship1.$model) = $event)),
                      options: state.countries,
                      class: _normalizeClass(validityColor('citizenship1'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).citizenship1.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).citizenship2.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_46,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.citizenship2,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((state.citizenship2) = $event)),
                      options: state.countries,
                      class: _normalizeClass(validityColor('citizenship2'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).citizenship2.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).residentType.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_48,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.residentType,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((state.residentType) = $event)),
                      options: state.residentTypes,
                      class: _normalizeClass(validityColor('residentType'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).residentType.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2), [
                    [_vShow, 
                  state.citizenship1 && state.citizenship1.label !== 'Canada'
                ]
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_citizenship
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).language1.hasOwnProperty('required') }])
                  }, [
                    _hoisted_51,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.language1,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((state.language1) = $event)),
                      options: state.languages,
                      class: _normalizeClass(validityColor('language1'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).language1.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).language2.hasOwnProperty('required') }])
                  }, [
                    _hoisted_53,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.language2,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((state.language2) = $event)),
                      options: state.languages,
                      class: _normalizeClass(validityColor('language2'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).language2.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_language
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).cob.hasOwnProperty('required') }])
                  }, [
                    _hoisted_56,
                    _createVNode(_unref(vSelect), {
                      modelValue: _unref($v).cob.$model,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref($v).cob.$model) = $event)),
                      options: state.countries,
                      class: _normalizeClass(validityColor('cob'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).cob.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).coo.hasOwnProperty('required') }])
                  }, [
                    _hoisted_58,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.coo,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((state.coo) = $event)),
                      options: state.countries,
                      class: _normalizeClass(validityColor('coo'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).coo.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_origins
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).studentReligion.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_61,
                    _createVNode(_unref(vSelect), {
                      modelValue: _unref($v).studentReligion.$model,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref($v).studentReligion.$model) = $event)),
                      options: state.religions,
                      class: _normalizeClass(validityColor('studentReligion'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).studentReligion.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).motherReligion.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_63,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.motherReligion,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((state.motherReligion) = $event)),
                      options: state.religions,
                      class: _normalizeClass(validityColor('motherReligion'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).motherReligion.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).fatherReligion.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_65,
                    _createVNode(_unref(vSelect), {
                      modelValue: state.fatherReligion,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((state.fatherReligion) = $event)),
                      options: state.religions,
                      class: _normalizeClass(validityColor('motherReligion'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (_unref($v).fatherReligion.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_66, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_religion
              ]
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).studentCell.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_68,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('studentCell')]),
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((state.studentCell) = $event)),
                      onBlur: _cache[27] || (_cache[27] = ($event: any) => (_unref($v).studentCell.$touch()))
                    }, null, 34), [
                      [_vModelText, state.studentCell],
                      [_unref(vMaska), '###-###-####']
                    ]),
                    (_unref($v).studentCell.$model && !_unref($v).studentCell.phoneValidator)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_69, " Not a valid phone number "))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).studentEmail.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_71,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('studentEmail')]),
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref($v).studentEmail.$model) = $event))
                    }, null, 2), [
                      [_vModelText, _unref($v).studentEmail.$model]
                    ]),
                    (!_unref($v).studentEmail.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, " This field is required "))
                      : _createCommentVNode("", true),
                    (_unref($v).studentEmail.required && !_unref($v).studentEmail.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, " Not a valid email address "))
                      : _createCommentVNode("", true),
                    (
                    _unref($v).studentEmail.required && !_unref($v).studentEmail.confirmEmail
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, " Student and parent email address cannot be the same "))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).studentEmail2.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_76,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('studentEmail2')]),
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref($v).studentEmail2.$model) = $event))
                    }, null, 2), [
                      [_vModelText, _unref($v).studentEmail2.$model]
                    ]),
                    (!_unref($v).studentEmail2.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, " This field is required "))
                      : _createCommentVNode("", true),
                    (
                    _unref($v).studentEmail2.required && !_unref($v).studentEmail2.confirmEmail
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, " Email addresses do not match "))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).ministryNo.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_80,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('ministryNo')]),
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref($v).ministryNo.$model) = $event))
                    }, null, 2), [
                      [_vModelText, _unref($v).ministryNo.$model]
                    ]),
                    (!_unref($v).ministryNo.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_additional_sis_data
              ]
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("div", null, [
                      _createVNode(_unref(BButton), {
                        variant: "info",
                        class: "text-white",
                        size: "sm",
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (
                      state.selectedCourses.push({
                        course: null,
                        startDate: null,
                        availableStartDates: [],
                        calendarAttrs: [],
                      })
                    ))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_85,
                          _createTextVNode(" Add a Course")
                        ], undefined, true),
                        _: 1
                      })
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.selectedCourses, (selection, index) => {
                  return (_openBlock(), _createBlock(_unref(BRow), { key: index }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(BCol), { class: "mt-4" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(BFormGroup), { label: "Course" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(vSelect), {
                                modelValue: state.selectedCourses[index].course,
                                "onUpdate:modelValue": ($event: any) => ((state.selectedCourses[index].course) = $event),
                                options: selectableCourses.value,
                                "onOption:selected": ($event: any) => (changeCourseInput(index))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onOption:selected"])
                            ], undefined, true),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_86, [
                            _createVNode(_unref(BButton), {
                              variant: "danger",
                              class: "my-2 btn-sm text-white",
                              onClick: ($event: any) => (removeSelectedCourse(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Remove Course")
                              ], undefined, true),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          (state.selectedCourses[index].course)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                _createTextVNode(" This course is "),
                                _createElementVNode("b", null, _toDisplayString(state.selectedCourses[index].course.length), 1),
                                _createTextVNode(" days long."),
                                _hoisted_88,
                                _hoisted_89
                              ]))
                            : _createCommentVNode("", true),
                          (
                    state.selectedCourses[index].course &&
                    state.selectedCourses[index].startDate
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                _createTextVNode(" You have chosen a start date of "),
                                _hoisted_91,
                                _createElementVNode("b", null, _toDisplayString(_unref(dateFormat)(
                        new Date(state.selectedCourses[index].startDate),
                        "mmmm dd, yyyy"
                      )), 1),
                                _createTextVNode("."),
                                _hoisted_92,
                                _hoisted_93,
                                (state.selectedCourses[index].willBeSuspended)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                                      _createTextVNode(" You will complete "),
                                      _createElementVNode("b", null, _toDisplayString(state.selectedCourses[index]
                        .amountCompleteBeforeSuspension), 1),
                                      _createTextVNode(" days of your course before it must be suspended for summer at midnight on "),
                                      _createElementVNode("b", null, _toDisplayString(_unref(dateFormat)(
                          new Date(
                            state.selectedCourses[index].semesterEndDate
                          ),
                          "mmmm dd, yyyy"
                        )), 1),
                                      _createTextVNode(". You will have "),
                                      _createElementVNode("b", null, _toDisplayString(state.selectedCourses[index].course?.length -
                      1 -
                      state.selectedCourses[index]
                        .amountCompleteBeforeSuspension), 1),
                                      _createTextVNode(" days remaining when your course resumes in September. ")
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_95, [
                                      _createTextVNode(" You will have access to your course until midnight on "),
                                      _hoisted_96,
                                      _createElementVNode("b", null, _toDisplayString(_unref(dateFormat)(
                        addDays(
                          new Date(state.selectedCourses[index].startDate),
                          state.selectedCourses[index].course?.length - 1
                        ),
                        "mmmm dd, yyyy"
                      )), 1),
                                      _hoisted_97,
                                      _createTextVNode("Final assessments will be scheduled prior to this date. ")
                                    ]))
                              ]))
                            : _createCommentVNode("", true)
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      _createVNode(_unref(BCol), { class: "mt-3 w-100 text-center" }, {
                        default: _withCtx(() => [
                          (_unref(selectedCourses)[index]?.course)
                            ? (_openBlock(), _createBlock(_unref(BFormGroup), {
                                key: 0,
                                label: "Dates"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_VDatePicker, {
                                    id: 'calendarDiv' + index,
                                    modelValue: _unref(selectedCourses)[index].startDate,
                                    "onUpdate:modelValue": ($event: any) => ((_unref(selectedCourses)[index].startDate) = $event),
                                    "popover-visibility": "focus",
                                    attributes: _unref(selectedCourses)[index].calendarAttrs,
                                    inline: true,
                                    expanded: true,
                                    "double-paned": true,
                                    linked: true,
                                    onDayclick: 
                      (calendarDay, event) => pickDate(calendarDay, index)
                    
                                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "attributes", "onDayclick"])
                                ], undefined, true),
                                _: 2
                              }, 1024))
                            : (_openBlock(), _createElementBlock("div", _hoisted_98, " Select a course to see potential dates "))
                        ], undefined, true),
                        _: 2
                      }, 1024),
                      (!state.selectedCourses[index].course)
                        ? (_openBlock(), _createBlock(_unref(BTooltip), {
                            key: 0,
                            target: 'calendarDiv' + index,
                            title: "Please select a course from the dropdown to see available dates"
                          }, null, 8, ["target"]))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 2
                  }, 1024))
                }), 128)),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).parentFirstName.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_100,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('parentFirstName')]),
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref($v).parentFirstName.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).parentFirstName.$model]
                      ]),
                      (!_unref($v).parentFirstName.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).parentLastName.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_102,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('parentLastName')]),
                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref($v).parentLastName.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).parentLastName.$model]
                      ]),
                      (!_unref($v).parentLastName.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).parentEmail.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_105,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('parentEmail')]),
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref($v).parentEmail.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).parentEmail.$model]
                      ]),
                      (!_unref($v).parentEmail.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_106, " This field is required "))
                        : _createCommentVNode("", true),
                      (_unref($v).parentEmail.required && !_unref($v).parentEmail.email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, " Not a valid email address "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).parentEmail2.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_109,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('parentEmail2')]),
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref($v).parentEmail2.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).parentEmail2.$model]
                      ]),
                      (!_unref($v).parentEmail2.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_110, " This field is required "))
                        : _createCommentVNode("", true),
                      (
                      _unref($v).parentEmail2.required && !_unref($v).parentEmail2.confirmEmail
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_111, " Email addresses do not match "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).parentPhone.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_113,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('parentPhone')]),
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((state.parentPhone) = $event)),
                        onBlur: _cache[37] || (_cache[37] = ($event: any) => (_unref($v).parentPhone.$touch()))
                      }, null, 34), [
                        [_vModelText, state.parentPhone],
                        [_unref(vMaska), '###-###-####']
                      ]),
                      (!_unref($v).parentPhone.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_114, " This field is required "))
                        : _createCommentVNode("", true),
                      (
                      _unref($v).parentPhone.required && !_unref($v).parentPhone.phoneValidator
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, " Not a valid phone number "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_parent
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).schoolDivision.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_117,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).schoolDivision.$model,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref($v).schoolDivision.$model) = $event)),
                      options: [...state.schoolDivisions, 'Other'],
                      class: _normalizeClass(validityColor('schoolDivision'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (!_unref($v).schoolDivision.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_118, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).schoolDivisionOther.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_119,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('schoolDivisionOther')]),
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref($v).schoolDivisionOther.$model) = $event))
                    }, null, 2), [
                      [_vModelText, _unref($v).schoolDivisionOther.$model]
                    ]),
                    (!_unref($v).schoolDivisionOther.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_120, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2), [
                    [_vShow, _unref($v).schoolDivision.$model == 'Other']
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_school_division
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_121, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).school.hasOwnProperty('required') }])
                  }, [
                    _hoisted_122,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).school.$model,
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref($v).school.$model) = $event)),
                      options: [...state.schools, 'Other'],
                      class: _normalizeClass(validityColor('school'))
                    }, null, 8, ["modelValue", "options", "class"]),
                    (!_unref($v).school.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_123, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).schoolOther.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_124,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: _normalizeClass(["form-control", validityColor('schoolOther')]),
                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref($v).schoolOther.$model) = $event))
                    }, null, 2), [
                      [_vModelText, _unref($v).schoolOther.$model]
                    ]),
                    (!_unref($v).schoolOther.required)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_125, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2), [
                    [_vShow, _unref($v).school.$model == 'Other']
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_school
              ]
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required:
                      _unref($v).schoolContactFirstName.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_127,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('schoolContactFirstName')]),
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref($v).schoolContactFirstName.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).schoolContactFirstName.$model]
                      ]),
                      (!_unref($v).schoolContactFirstName.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required:
                      _unref($v).schoolContactLastName.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_129,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('schoolContactLastName')]),
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref($v).schoolContactLastName.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).schoolContactLastName.$model]
                      ]),
                      (!_unref($v).schoolContactLastName.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_130, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).schoolContactEmail.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_132,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('schoolContactEmail')]),
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_unref($v).schoolContactEmail.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).schoolContactEmail.$model]
                      ]),
                      (!_unref($v).schoolContactEmail.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_133, " This field is required "))
                        : _createCommentVNode("", true),
                      (
                      _unref($v).schoolContactEmail.required &&
                      !_unref($v).schoolContactEmail.email
                    )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_134, " Not a valid email address "))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_school_contact
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_135, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-12", {
                  required:
                    _unref($v).attendingOtherSchoolDivision.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_136,
                    _createElementVNode("div", _hoisted_137, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-check-input", validityColor('attendingOtherSchoolDivision')]),
                        type: "radio",
                        name: "exampleRadios",
                        id: "exampleRadios1",
                        value: "true",
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((state.attendingOtherSchoolDivision) = $event))
                      }, null, 2), [
                        [_vModelRadio, state.attendingOtherSchoolDivision]
                      ]),
                      _hoisted_138
                    ]),
                    _createElementVNode("div", _hoisted_139, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["form-check-input", validityColor('attendingOtherSchoolDivision')]),
                        type: "radio",
                        name: "exampleRadios",
                        id: "exampleRadios2",
                        value: "false",
                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((state.attendingOtherSchoolDivision) = $event))
                      }, null, 2), [
                        [_vModelRadio, state.attendingOtherSchoolDivision]
                      ]),
                      _hoisted_140
                    ]),
                    (
                    !_unref($v).attendingOtherSchoolDivision.required &&
                    _unref($v).attendingOtherSchoolDivision.$dirty
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_141, " This field is required "))
                      : _createCommentVNode("", true)
                  ], 2),
                  _withDirectives(_createElementVNode("div", _hoisted_142, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required:
                      _unref($v).lastAttendedSchoolDivision.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_143,
                      _createVNode(_unref(BFormSelect), {
                        modelValue: _unref($v).lastAttendedSchoolDivision.$model,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref($v).lastAttendedSchoolDivision.$model) = $event)),
                        options: [...state.schoolDivisions, 'Other'],
                        class: _normalizeClass(validityColor('lastAttendedSchoolDivision'))
                      }, null, 8, ["modelValue", "options", "class"]),
                      (!_unref($v).lastAttendedSchoolDivision.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass(["form-group col mt-3", {
                    required:
                      _unref($v).lastAttendedSchoolDivisionOther.hasOwnProperty(
                        'required'
                      ),
                  }])
                    }, [
                      _hoisted_145,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('lastAttendedSchoolDivisionOther')]),
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref($v).lastAttendedSchoolDivisionOther.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).lastAttendedSchoolDivisionOther.$model]
                      ]),
                      (!_unref($v).lastAttendedSchoolDivisionOther.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_146, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2), [
                      [_vShow, _unref($v).lastAttendedSchoolDivision.$model == 'Other']
                    ])
                  ], 512), [
                    [_vShow, 
                  state.studentType &&
                  state.studentTypes.filter((a) => a.id == state.studentType)[0]
                    .require_attending_other_school_div &&
                  state.attendingOtherSchoolDivision == 'false'
                ]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required: _unref($v).lastAttendedSchool.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_148,
                      _createVNode(_unref(BFormSelect), {
                        modelValue: _unref($v).lastAttendedSchool.$model,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_unref($v).lastAttendedSchool.$model) = $event)),
                        options: [...state.schools, 'Other'],
                        class: _normalizeClass(validityColor('lastAttendedSchool'))
                      }, null, 8, ["modelValue", "options", "class"]),
                      (!_unref($v).lastAttendedSchool.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2),
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass(["form-group col", {
                    required:
                      _unref($v).lastAttendedSchoolOther.hasOwnProperty('required'),
                  }])
                    }, [
                      _hoisted_150,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control", validityColor('lastAttendedSchoolOther')]),
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_unref($v).lastAttendedSchoolOther.$model) = $event))
                      }, null, 2), [
                        [_vModelText, _unref($v).lastAttendedSchoolOther.$model]
                      ]),
                      (!_unref($v).lastAttendedSchoolOther.required)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_151, " This field is required "))
                        : _createCommentVNode("", true)
                    ], 2), [
                      [_vShow, _unref($v).lastAttendedSchool.$model == 'Other']
                    ])
                  ], 512), [
                    [_vShow, 
                  state.studentType &&
                  state.studentTypes.filter((a) => a.id == state.studentType)[0]
                    .require_attending_other_school_div &&
                  state.attendingOtherSchoolDivision == 'false'
                ]
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["col-12 big-date mt-3 mb-2", {
                  required: _unref($v).lastAttendedDate.hasOwnProperty('required'),
                }])
                  }, [
                    _createVNode(_component_CDatePicker, {
                      class: _normalizeClass([validityColor('lastAttendedDate'), "mb-0"]),
                      label: "Date of Withdrawal",
                      "onUpdate:date": _cache[51] || (_cache[51] = (date) => (_unref($v).lastAttendedDate.$model = date))
                    }, null, 8, ["class"])
                  ], 2), [
                    [_vShow, 
                  state.studentType &&
                  state.studentTypes.filter((a) => a.id == state.studentType)[0]
                    .require_attending_other_school_div &&
                  state.attendingOtherSchoolDivision == 'false'
                ]
                  ])
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_attending_other_school_div
              ]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_152, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", {
                  required: _unref($v).partnerInEducation.hasOwnProperty('required'),
                }])
                  }, [
                    _hoisted_153,
                    _createVNode(_unref(BFormSelect), {
                      modelValue: _unref($v).partnerInEducation.$model,
                      "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_unref($v).partnerInEducation.$model) = $event)),
                      options: state.educationPartners,
                      class: _normalizeClass(validityColor('partnerInEducation'))
                    }, null, 8, ["modelValue", "options", "class"])
                  ], 2)
                ], 512), [
                  [_vShow, 
                state.studentType &&
                state.studentTypes.filter((a) => a.id == state.studentType)[0]
                  .require_partner_in_education &&
                state.educationPartners.length > 0
              ]
                ]),
                _hoisted_154,
                _hoisted_155,
                _createElementVNode("div", _hoisted_156, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-group col", { required: _unref($v).notes.hasOwnProperty('required') }])
                  }, [
                    _hoisted_157,
                    _hoisted_158,
                    _hoisted_159,
                    (_unref($v).notes.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_160, " This field is required "))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(BFormTextarea), {
                      id: "textarea1",
                      modelValue: _unref($v).notes.$model,
                      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_unref($v).notes.$model) = $event)),
                      placeholder: "",
                      rows: 3,
                      "max-rows": 6,
                      class: _normalizeClass(["mt-1", { 'border-danger': _unref($v).notes.$error }])
                    }, null, 8, ["modelValue", "class"])
                  ], 2)
                ]),
                _createElementVNode("div", _hoisted_161, [
                  _createElementVNode("div", _hoisted_162, [
                    _createVNode(_unref(BFormCheckbox), {
                      modelValue: _unref($v).eligibilityGuidelines.$model,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_unref($v).eligibilityGuidelines.$model) = $event)),
                      class: "required"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Eligibility Guidelines were considered while processing registration")
                      ], undefined, true),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_unref(BFormCheckbox), {
                      modelValue: _unref($v).prereqs.$model,
                      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_unref($v).prereqs.$model) = $event)),
                      class: "required"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pre-requisite courses, if required, have been completed")
                      ], undefined, true),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_unref(BFormCheckbox), {
                      modelValue: _unref($v).accurate.$model,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_unref($v).accurate.$model) = $event)),
                      class: "required"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Information provided is accurate and truthful")
                      ], undefined, true),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_unref(BFormCheckbox), {
                      modelValue: _unref($v).recordsShared.$model,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_unref($v).recordsShared.$model) = $event)),
                      class: "required"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("I am aware that educational records and applicable information will be shared with and accessed from previous and/or current schools")
                      ], undefined, true),
                      _: 1
                    }, 8, ["modelValue"]),
                    (
                    _unref($v).eligibilityGuidelines.$error ||
                    _unref($v).prereqs.$error ||
                    _unref($v).accurate.$error ||
                    _unref($v).recordsShared.$error
                  )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_163, " Please indicate your agreement to all of the above "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_164, [
                  _createElementVNode("div", _hoisted_165, [
                    (state.loadRecaptcha)
                      ? (_openBlock(), _createBlock(_unref(vueRecaptcha), {
                          key: 0,
                          ref_key: "invisibleRecaptcha",
                          ref: invisibleRecaptcha,
                          onExpire: onExpired,
                          onVerify: recaptchaCallback,
                          sitekey: "6LdZ730UAAAAAGUsCZJW6MlDv7blUDBW630j83XE",
                          size: "invisible"
                        }, null, 512))
                      : _createCommentVNode("", true),
                    _hoisted_166,
                    _createElementVNode("div", _hoisted_167, [
                      _createVNode(_unref(BButton), {
                        type: "button",
                        block: "",
                        variant: "primary",
                        onClick: verifyData,
                        disabled: !state.buttonEnabled
                      }, {
                        default: _withCtx(() => [
                          _hoisted_168
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("div", _hoisted_171, [
                    _hoisted_172,
                    _hoisted_173,
                    _hoisted_174,
                    _createElementVNode("p", null, " Once your placement has been reviewed and approved you will receive an email at " + _toDisplayString(state.studentEmail) + " where you will be provided instructions on your next steps. ", 1),
                    (
                    state.studentType &&
                    state.studentTypes.filter(
                      (a) => a.id == state.studentType
                    )[0].require_parent
                  )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_175, " Additionally, " + _toDisplayString(state.parentEmail) + " will also be receiving an email with additional steps required. ", 1))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(BButton), {
                      variant: "warning",
                      class: "ml-2 text-white",
                      onClick: resetForm
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reset Form")
                      ], undefined, true),
                      _: 1
                    })
                  ])
                ])
              ]))
        ])
      ])
    ]),
    _createVNode(LoadingModal, { visible: showLoading.value }, null, 8, ["visible"]),
    _createVNode(ErrorModal, { visible: showError.value }, null, 8, ["visible"])
  ]))
}
}

})